import { render, staticRenderFns } from "./list_item_stat.vue.js?vue&type=template&id=4d792c44!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_stat.vue?vue&type=template&id=4d792c44"
import script from "./list_item_stat.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_stat.vue?vue&type=script&lang=js"
export * from "./list_item_stat.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_stat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d792c44')) {
      api.createRecord('4d792c44', component.options)
    } else {
      api.reload('4d792c44', component.options)
    }
    module.hot.accept("./list_item_stat.vue.js?vue&type=template&id=4d792c44!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_stat.vue?vue&type=template&id=4d792c44", function () {
      api.rerender('4d792c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/resource_lists/list_item_stat.vue"
export default component.exports